import ApiService from '@/services/api.service'
import { Notify } from 'quasar'

export const antenneDiplomeSessionDetails = {
  state: {
    sessionDetails: [],
    sessionDetail: null,
  },

  mutations: {
    setSessionDetails(state, details) {
      state.sessionDetails = details
    },
    setSessionDetail(state, detail) {
      state.sessionDetail = detail
    },
  },

  actions: {
    // Liste complète
    async fetchSessionDetails(context) {
      try {
        const response = await ApiService.getRequest('antenne_diplome_session_details')
        context.commit('setSessionDetails', response.data['hydra:member'])
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur de chargement des détails", color: 'red' })
      }
    },

    // Récupération par ID (via URL hydra)
    async fetchSessionDetailById(context, url) {
      try {
        const response = await ApiService.getRequest(url)
        context.commit('setSessionDetail', response.data)
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur de chargement du détail", color: 'red' })
      }
    },

    // Ajout
    async addSessionDetail(context, data) {
      try {
        const response = await ApiService.postRequest('antenne_diplome_session_details', data)
        context.commit('setSessionDetail', response.data)
        return response.data

        Notify.create({ message: "Détail ajouté avec succès", color: 'green' })
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de l'ajout du détail", color: 'red' })
      }
    },

    // Édition
    async editSessionDetail(context, { url, data }) {
      try {
        const response = await ApiService.patchRequest(url, data)
        context.commit('setSessionDetail', response.data)

        Notify.create({
          message: "Détail modifié avec succès",
          color: 'green'
        })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Erreur lors de la modification",
          color: 'red'
        })
      }
    },

    // Suppression
    async deleteSessionDetail(context, url) {
      try {
        await ApiService.deleteRequest(url)
        Notify.create({ message: "Détail supprimé avec succès", color: 'green' })
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la suppression", color: 'red' })
      }
    },

    // *******************************************************************
    // AJOUT D'UN STAGE LIÉ AU SESSION_DETAIL
    async addAntenneDiplomeSessionDetailStage({ }, data) { // pas besoin de commit
      try {
        // adapte le endpoint si besoin ('stages' par ex. dans l'API)
        const response = await ApiService.postRequest('antenne_diplome_session_detail_stages', data)
        Notify.create({ message: "Stage ajouté avec succès", color: 'green' })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de l'ajout d'un stage", color: 'red' })
        throw error
      }
    },

    async editAntenneDiplomeSessionDetailStage({ }, { url, data }) {
      try {
        const response = await ApiService.patchRequest(url, data)
        Notify.create({ message: "Stage modifié avec succès", color: 'green' })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la modification du stage", color: 'red' })
        throw error
      }
    },

    async deleteAntenneDiplomeSessionDetailStage({}, id) {
      try {
        const resp = await ApiService.deleteRequest(`antenne_diplome_session_detail_stages/${id}`)

        Notify.create({ message: "Stage supprimé avec succès", color: 'green' })
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la suppression", color: 'red' })
      }
    },

    // *******************************************************************
    // GESTION DES PARCOURS
    async addAntenneDiplomeSessionDetailParcours({ }, data) {
      try {
        const response = await ApiService.postRequest('antenne_diplome_session_detail_parcours', data)
        Notify.create({ message: "Parcours ajouté avec succès", color: 'green' })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de l'ajout du parcours", color: 'red' })
        throw error
      }
    },

    async editAntenneDiplomeSessionDetailParcours({ }, { url, data }) {
      try {
        const response = await ApiService.patchRequest(url, data)
        Notify.create({ message: "Parcours modifié avec succès", color: 'green' })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la modification du parcours", color: 'red' })
        throw error
      }
    },

    async deleteAntenneDiplomeSessionDetailParcours({}, id) {
      try {
        const resp = await ApiService.deleteRequest(`antenne_diplome_session_detail_parcours/${id}`)
        Notify.create({ message: "Parcours supprimé avec succès", color: 'green' })
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la suppression du parcours", color: 'red' })
      }
    },

    // *******************************************************************
    // GESTION DES ÉVALUATIONS
    async addAntenneDiplomeSessionDetailEvaluation({ }, data) {
      try {
        const response = await ApiService.postRequest('antenne_diplome_session_detail_evaluations', data)
        Notify.create({ message: "Évaluation ajoutée avec succès", color: 'green' })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de l'ajout de l'évaluation", color: 'red' })
        throw error
      }
    },

    async editAntenneDiplomeSessionDetailEvaluation({ }, { url, data }) {
      try {
        const response = await ApiService.patchRequest(url, data)
        Notify.create({ message: "Évaluation modifiée avec succès", color: 'green' })
        return response.data
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la modification de l'évaluation", color: 'red' })
        throw error
      }
    },

    async deleteAntenneDiplomeSessionDetailEvaluation({}, id) {
      try {
        const resp = await ApiService.deleteRequest(`antenne_diplome_session_detail_evaluations/${id}`)
        Notify.create({ message: "Évaluation supprimée avec succès", color: 'green' })
      } catch (error) {
        console.error(error)
        Notify.create({ message: "Erreur lors de la suppression de l'évaluation", color: 'red' })
      }
    }
  },

  getters: {
    getSessionDetails(state) {
      return state.sessionDetails
    },
    getSessionDetail(state) {
      return state.sessionDetail
    }
  }
}
